export interface ViesDetailRow {
  label: string
  value: string
}

export interface ViesValidationView {
  valid: boolean
  countryCode: string
  vatNumber: string
  name: string
  address: string
  error: string
}

export interface ViesValidatorScreenDataInterface {
  isLoading: boolean
  isError: boolean
  hide: boolean
  valid: boolean
  countryCode: string
  vatNumber: string
  name: string
  address: string
  message: string
  detailRows: ViesDetailRow[]
}

export const createScreenData = (): ViesValidatorScreenDataInterface => ({
  isLoading: false,
  isError: false,
  hide: false,
  valid: false,
  countryCode: '',
  vatNumber: '',
  name: '',
  address: '',
  message: '',
  detailRows: []
})

export class ViesValidatorComponent {
  constructor(
    private readonly application: { validateVies(cif: string, country: string): Promise<ViesValidationView> },
    private readonly screenData: ViesValidatorScreenDataInterface
  ) {}

  private buildDetailRows(): ViesDetailRow[] {
    if (!this.screenData.valid) {
      return []
    }
    const rows: ViesDetailRow[] = [{ label: 'Estado', value: 'VALIDADO' }]
    if (this.screenData.name) {
      rows.push({ label: 'Nombre', value: this.screenData.name })
    }
    if (this.screenData.address) {
      rows.push({ label: 'Dirección', value: this.screenData.address })
    }
    if (this.screenData.countryCode) {
      rows.push({ label: 'País', value: this.screenData.countryCode })
    }
    if (this.screenData.vatNumber) {
      rows.push({ label: 'NIF', value: this.screenData.vatNumber })
    }
    return rows
  }

  async validateVies(cif: string | null, country: string): Promise<void> {
    this.screenData.isLoading = true
    this.screenData.hide = false
    this.screenData.isError = false
    this.screenData.valid = false
    this.screenData.detailRows = []

    if (!cif) {
      this.screenData.hide = true
      this.screenData.isLoading = false
      return
    }

    try {
      const result = await this.application.validateVies(cif, country)

      if (result.error) {
        this.screenData.message = result.error
        this.screenData.isError = true
        this.screenData.valid = false
      } else {
        this.screenData.countryCode = result.countryCode
        this.screenData.vatNumber = result.vatNumber
        this.screenData.name = result.name
        this.screenData.address = result.address
        this.screenData.valid = result.valid
        this.screenData.message = result.valid ? 'VIES válido' : ''
      }
      this.screenData.detailRows = this.buildDetailRows()
    } catch (e) {
      this.screenData.message = 'No se pudo validar el CIF con VIES'
      this.screenData.isError = true
    } finally {
      this.screenData.isLoading = false
    }
  }
}
